<template>
  <div>
    <div id="maskParties" v-if="formLoading">
      <p v-if="formLoading">
        <span>CHARGEMENT EN COURS (merci de patienter)</span>
        <v-progress-linear indeterminate color="#1f8388"></v-progress-linear>
      </p>
    </div>
    <div id="parties">
      <Partie1
        :dossier="this.dossier"
        @save="saveDossier(1)"
        @nextPart="gotoPart(2)"
        v-if="isPart(1)"
      />
      <div v-else-if="isPart(2)">
        <Partie2
          :dossier="this.dossier"
          @save="saveDossier(2)"
          @nextPart="gotoPart(4)"
          v-if="dossier.premiereDemande"
        />
        <Partie2
          :dossier="this.dossier"
          @save="saveDossier(2)"
          @nextPart="gotoPart(3)"
          v-else
        />
      </div>
      <Partie3
        :dossier="this.dossier"
        @save="saveDossier(3)"
        @nextPart="gotoPart(4)"
        v-else-if="isPart(3)"
      />
      <Partie4
        :dossier="this.dossier"
        @save="saveDossier(4)"
        @nextPart="gotoPart(5)"
        v-else-if="isPart(4)"
      />
      <Partie5
        :dossier="this.dossier"
        @save="saveDossier(5)"
        @nextPart="gotoPart(6)"
        v-else-if="isPart(5)"
      />
      <Partie6
        :dossier="this.dossier"
        @save="saveDossier(6)"
        @nextPart="gotoPart(7)"
        v-else-if="isPart(6)"
      />
      <Partie7
        :dossier="this.dossier"
        @save="saveDossier(7)"
        @nextPart="gotoPart(8)"
        v-else-if="isPart(7)"
      />
      <Partie8
        :dossier="this.dossier"
        @save="saveDossier(8)"
        @nextPart="gotoPart(9)"
        v-else-if="isPart(8)"
      />
      <Partie9
        :dossier="this.dossier"
        @save="saveDossier(9)"
        @nextPart="gotoPart(10)"
        v-else-if="isPart(9)"
      />
      <Partie10
        :dossier="this.dossier"
        @save="saveDossier(10)"
        @nextPart="gotoPart(11)"
        v-else-if="isPart(10)"
      />
      <Partie11
        :dossier="this.dossier"
        @save="saveDossier(11)"
        @nextPart="gotoPart(12)"
        v-else-if="isPart(11)"
      />
      <Partie12
        :dossier="this.dossier"
        @save="saveDossier(12)"
        @nextPart="gotoPart(13)"
        v-else-if="isPart(12)"
      />
      <Partie13
        :dossier="this.dossier"
        @save="saveDossier(13)"
        @nextPart="gotoPart(14)"
        v-else-if="isPart(13)"
      />
      <Partie14
        :dossier="this.dossier"
        @save="saveDossier(14)"
        @nextPart="gotoPart(15)"
        v-else-if="isPart(14)"
      />
      <Partie15
        :dossier="this.dossier"
        @save="saveDossier(15)"
        @nextPart="gotoPart(16)"
        v-else-if="isPart(15)"
      />
      <Partie16
        :dossier="this.dossier"
        @save="saveDossier(16)"
        @nextPart="gotoPart(17)"
        v-else-if="isPart(16)"
      />
      <Partie17
        :dossier="this.dossier"
        @save="saveDossier(17)"
        @nextPart="gotoPart(18)"
        v-else-if="isPart(17)"
      />
      <Partie18
        :dossier="this.dossier"
        @save="saveDossier(18)"
        @valid="validDossier()"
        v-else-if="isPart(18)"
      />
      <Partie0
        :dossier="this.dossier"
        @save="saveDossier(0)"
        @nextPart="gotoPart(1)"
        v-else
      />
    </div>
  </div>
</template>

<script>
import Partie0 from "@/components/formulaire/Partie0";
import Partie1 from "@/components/formulaire/Partie1";
import Partie2 from "@/components/formulaire/Partie2";
import Partie3 from "@/components/formulaire/Partie3";
import Partie4 from "@/components/formulaire/Partie4";
import Partie5 from "@/components/formulaire/Partie5";
import Partie6 from "@/components/formulaire/Partie6";
import Partie7 from "@/components/formulaire/Partie7";
import Partie8 from "@/components/formulaire/Partie8";
import Partie9 from "@/components/formulaire/Partie9";
import Partie10 from "@/components/formulaire/Partie10";
import Partie11 from "@/components/formulaire/Partie11";
import Partie12 from "@/components/formulaire/Partie12";
import Partie13 from "@/components/formulaire/Partie13";
import Partie14 from "@/components/formulaire/Partie14";
import Partie15 from "@/components/formulaire/Partie15";
import Partie16 from "@/components/formulaire/Partie16";
import Partie17 from "@/components/formulaire/Partie17";
import Partie18 from "@/components/formulaire/Partie18";

import { mapState } from "vuex";
import ApiDossierRepository from "@/repositories/ApiDossierRepository";

export default {
  name: "Parties",
  components: {
    Partie0,
    Partie1,
    Partie2,
    Partie3,
    Partie4,
    Partie5,
    Partie6,
    Partie7,
    Partie8,
    Partie9,
    Partie10,
    Partie11,
    Partie12,
    Partie13,
    Partie14,
    Partie15,
    Partie16,
    Partie17,
    Partie18
  },
  computed: {
    ...mapState(["dossier", "formLoading"])
  },
  methods: {
    onLoading(bool) {
      this.$store.dispatch("setFormLoading", bool);
    },
    isPart(idPart) {
      return (
        this.$route.path == "/dossier/" + this.dossier.id + "/part/" + idPart
      );
    },
    gotoPart(idPart) {
      let nextRouteDatas = {
        iddossier: this.dossier.id,
        part: idPart
      };
      this.$router.push({ name: "formulaire-part", params: nextRouteDatas });
    },
    async saveDossier(idPart) {
      this.onLoading(true);
      let parts = JSON.parse(this.dossier.parties);
      if (parts == null) {
        this.dossier.parties = "[" + idPart + "]";
      } else {
        let isAlreadyDedans =
          parts.filter(part => part == idPart)[0] != undefined;
        if (!isAlreadyDedans) {
          parts.push(idPart);
          this.dossier.parties = JSON.stringify(parts);
        }
      }
      await ApiDossierRepository.update(
        this.dossier.id,
        this.dossier.codeAcces,
        this.dossier
      );
      await this.updateStoredDossier();
      this.onLoading(false);
    },
    async validDossier() {
      this.onLoading(true);
      if (JSON.parse(this.dossier.parties).length >= 17) {
        await ApiDossierRepository.setEtatExamenAdministratif(
          this.dossier.id,
          this.dossier
        );
        await this.updateStoredDossier();
      }
      this.onLoading(false);
    },
    async updateStoredDossier() {
      const dossier = await ApiDossierRepository.get(
        this.dossier.id,
        this.dossier.codeAcces
      );
      this.$store.dispatch("setDossier", dossier);
    }
  }
};
</script>
<style>
#maskParties {
  background-color: rgba(237, 237, 237, 0.7);
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 10;
}
#maskParties p {
  width: 100%;
  height: 100%;
  text-align: center;
  padding-top: 150px;
}
#maskParties p span {
  position: relative;
  margin-left: auto;
  margin-right: auto;
  font-weight: bold;
  color: #1f8388;
}
#parties {
  z-index: 0;
}
</style>
